import { getTimestamp, msToNs } from '@datadog/browser-core';
import { RumEventCategory } from '../../../types';
import { RumEventType } from '../../../typesV2';
import { LifeCycleEventType } from '../../lifeCycle';
export function startLongTaskCollection(lifeCycle, configuration) {
    lifeCycle.subscribe(LifeCycleEventType.PERFORMANCE_ENTRY_COLLECTED, function (entry) {
        if (entry.entryType !== 'longtask') {
            return;
        }
        if (configuration.isEnabled('v2_format')) {
            var rawRumEvent = {
                date: getTimestamp(entry.startTime),
                longTask: {
                    duration: msToNs(entry.duration),
                },
                type: RumEventType.LONG_TASK,
            };
            lifeCycle.notify(LifeCycleEventType.RAW_RUM_EVENT_V2_COLLECTED, {
                rawRumEvent: rawRumEvent,
                startTime: entry.startTime,
            });
        }
        else {
            var rawRumEvent = {
                date: getTimestamp(entry.startTime),
                duration: msToNs(entry.duration),
                evt: {
                    category: RumEventCategory.LONG_TASK,
                },
            };
            lifeCycle.notify(LifeCycleEventType.RAW_RUM_EVENT_COLLECTED, {
                rawRumEvent: rawRumEvent,
                startTime: entry.startTime,
            });
        }
    });
}
//# sourceMappingURL=longTaskCollection.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@datadog/browser-rum/esm/domain/rumEventsCollection/longTask/longTaskCollection.js
// module id = p0zT
// module chunks = 1